import {
  InformationCircleIcon
} from "@heroicons/react/24/outline";
import { RichInput, TextInput, UploadBox } from "components";
import { ComplaintCategoryPicker, ComplaintTypePicker } from "containers";
import { FormikProps } from "formik";
import parse from 'html-react-parser';
import { FC } from "react";

type Props = {
  form: FormikProps<any>};

export const TicketForm: FC<Props> = ({ form }) => {
  
  return (
    <div className="space-y-6 divide-y no-scrollbar divide-gray-200 flex-1 overflow-y-auto p-6">
    
      <div>
        <span className="text-xs font-light">Contact Person Information</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div className="col-span-3">
            <TextInput
              id="contactPersonInfo.fullName"
              label="Full Name"
              type="text"
              required
              placeholder="e.g. Emmanuel Baidoo"
              {...form}
            />
          </div>

          <div className="col-span-2">
            <TextInput
              id="contactPersonInfo.emailAddress"
              label="Email Address"
              type="text"
              placeholder="e.g. ebaidoo@office.com"
              {...form}
            />
          </div>
          <div className="">
            <TextInput
              id="contactPersonInfo.phoneNumber"
              label="Phone Number"
              type="text"
              placeholder="e.g. 0506339153"
              required
              {...form}
            />
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">Complaint Type Information</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="space-y-1">
            <ComplaintCategoryPicker
              id="complaintInfo.category"
              label="Complaint Category"
              required
              {...form}
            />
          </div>
          <div>
            <ComplaintTypePicker
              id="complaintInfo.type"
              label="Complaint Type"
              required
              disabled={!form.values?.complaintInfo?.category}
              filter={{ category: form.values?.complaintInfo?.category?.name }}
              {...form}
            />
          </div>
          {form.values.complaintInfo?.type?.description && (
            <div className="rounded-md bg-yellow-50 p-4 col-span-2">
              <div className="flex">
                <div className="flex-shrink-0">
                  <InformationCircleIcon
                    className="h-5 w-5 text-yellow-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <div className="text-sm text-yellow-700">
                    <h2 className="font-medium">Info About Complaint Type</h2>
                    <p className="mt-1">{parse(form.values.complaintInfo?.type?.description)}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-span-2 mb-4">
            <RichInput
              id="complaintInfo.description"
              label="Description"
              placeholder="e.g. Connected the cables underground from next door"
              required
              {...form}
            />
          </div>
          <div className="col-span-2">
            <UploadBox
              label="Supporting document"
              required={form.values.complaintInfo?.type?.requiresDocument}
              multiple
              id={"complaintInfo.supportingDocumentUrls"}
              {...form}
            />
          </div>
        </div>
      </div>

    </div>
  );
};

export default TicketForm;
